import { Injectable } from '@angular/core';
import { CRUDService } from '../../core/services/crud.service';
import { Inventario } from '../entities/inventario';
import { SesionService } from '../../core/services/session.service';
import { FilterQuery } from '../../core/entities/filter-query';
import { Criteria } from '../../core/entities/filter';
import { HttpInt } from 'src/app/httpInt';
import { MensajeUsuarioService } from '../../comun/services/mensaje-usuario.service';

@Injectable({
  providedIn: 'root'
})
export class InventarioService extends CRUDService<Inventario> {

  constructor(
    public override httpInt: HttpInt,
    public override mensajeUsuarioService: MensajeUsuarioService,
    private sesionService: SesionService
  ) {
    super(httpInt, mensajeUsuarioService);
  }

  getClassName(): string {
    return "InventarioService";
  }

  // Override findAll para filtrar manualmente por empresa
  // El backend de inventario NO tiene filtro automático por empresa
  override findAll() {
    const empresaId = this.sesionService.getEmpresa()?.id;
    console.log('🏢 Filtrando inventarios por empresa (filtro manual):', empresaId);
    
    if (!empresaId) {
      console.error('❌ No hay empresa seleccionada');
      return Promise.reject(new Error('No hay empresa seleccionada'));
    }
    
    const filterQuery = new FilterQuery();
    filterQuery.filterList = [
      {
        field: 'idEmpresa',
        value1: empresaId,
        criteria: Criteria.EQUALS
      }
    ];
    filterQuery.count = true;
    filterQuery.rows = 1000; // Suficiente para inventarios
    filterQuery.offset = 0;
    
    console.log('🚀 Enviando filtro manual por idEmpresa:', filterQuery);
    return this.findByFilter(filterQuery);
  }

  // Override create para asignar empresa automáticamente
  override create(entity: Inventario) {
    entity.idEmpresa = Number(this.sesionService.getEmpresa()?.id);
    console.log('📝 Creando inventario para empresa:', entity.idEmpresa);
    return super.create(entity);
  }

  // Override update para mantener empresa
  override update(entity: Inventario, filter?: string) {
    entity.idEmpresa = Number(this.sesionService.getEmpresa()?.id);
    console.log('✏️ Actualizando inventario para empresa:', entity.idEmpresa);
    return super.update(entity, filter);
  }

  finById(id: number) {
    return this.httpInt.get(`${this.end_point}findById/${id}`);
  }
}
